module.exports = __webpack_public_path__ + "static/media/DK_Logo.1e897ea8.png";